import * as React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPhone,
    faEnvelope,
    faUserAlt,
    faMapMarkerAlt,
    faExternalLinkSquareAlt,
    faAddressCard,
    faTrophy,
    faExclamationTriangle,
    faFlag
} from "@fortawesome/free-solid-svg-icons";

import { SimpleCustomer, ExtractFriendlyName } from "src/model/Customer";
import { UncontrolledTooltip } from "reactstrap";

export const CustomerLinkCheckout = ({
    customer,
    isWinningBider,
    notHaveAgentAuthorization,
    page
}: {
    page: string;
    customer: SimpleCustomer | null;
    isWinningBider?: boolean;
    notHaveAgentAuthorization?: boolean;
}) => {
    if (!customer) {
        return <div />;
    }
    return (
        <>
            <Link
                to={`/customer/${customer.id}/page`}
                className={`d-flex justify-content-start align-items-center flex-nowrap ml-2  ${isWinningBider && `text-info`}`}
                target={"_blank"}
            >
                {isWinningBider && (
                    <>
                        <div id={`winningBidder_${customer.id}`}>
                            <FontAwesomeIcon icon={faTrophy} className="mr-2 " />
                        </div>
                        <UncontrolledTooltip placement="top" target={`winningBidder_${customer.id}`} delay={0} className="tooltipstrap">
                            Winner Bidder
                        </UncontrolledTooltip>
                    </>
                )}
                {notHaveAgentAuthorization && (
                    <>
                        <div id={`tooltipMissingAgent_${customer.id}`}>
                            <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger mr-2" />
                        </div>
                        <UncontrolledTooltip placement="top" target={`tooltipMissingAgent_${customer.id}`} delay={0} className="tooltipstrap">
                            Agent Authorization not present
                        </UncontrolledTooltip>
                    </>
                )}
                <div id={`tooltip_flagged_${customer.id}`} className={`nowrap-white-space ${customer.dateFlagged && `text-danger`}`}>
                    {ExtractFriendlyName(customer)}
                </div>
                {customer.dateFlagged && (
                    <UncontrolledTooltip placement="top" target={`tooltip_flagged_${customer.id}`} delay={0} className="tooltipstrap">
                        <FontAwesomeIcon icon={faFlag} className="mr-2 fa-sm" style={{ color: "FFB62E" }} /> {customer.flaggedNotes}
                    </UncontrolledTooltip>
                )}
                <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 fa-sm" />
            </Link>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/CustomerLinkCheckout.tsx